if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        
        const giftProductId = window.subscriptionGiftSettings?.giftProductId || '7723756683315';
        
        if (window.productData && window.productData.id && window.productData.id.toString() === giftProductId) {
          const isFromSubscription = localStorage.getItem('allowFreeGiftAdd') === 'true';
          
          if (!isFromSubscription) {
            this.handleErrorMessage('This item is only available as a gift with subscription purchases.');
            return;
          }
          
          localStorage.removeItem('allowFreeGiftAdd');
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('No cart drawer detected, checking for subscription...');
              console.log('Product ID:', window.productData?.id);
              
              const subscriptionProductId = window.subscriptionGiftSettings?.subscriptionProductId || '7722874798131';
              const isEnabled = window.subscriptionGiftSettings?.enabled !== false;
              
              if (isEnabled && window.productData && window.productData.id.toString() === subscriptionProductId) {
                const isSubscriptionSelected = this.checkSubscriptionSelected();
                console.log('Is subscription selected:', isSubscriptionSelected);
                
                if (isSubscriptionSelected) {
                  const quantityInput = document.querySelector('input[name="quantity"]');
                  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
                  
                  console.log('Adding gift product before redirect...');
                  await this.addGiftProduct(quantity);
                  console.log('Gift product added, now redirecting...');
                }
              }
              
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      checkSubscriptionSelected() {
        const widget = document.querySelector('recharge-subscription-widget');
        if (!widget) return false;

        let onetimeSelected = widget.querySelector('.rc-selection__onetime[rc-selected]');
        let subscriptionSelected = widget.querySelector('.rc-purchase-option__subscription[rc-selected]');

        if (widget.shadowRoot) {
          onetimeSelected = onetimeSelected || widget.shadowRoot.querySelector('.rc-selection__onetime[rc-selected]');
          subscriptionSelected = subscriptionSelected || widget.shadowRoot.querySelector('.rc-purchase-option__subscription[rc-selected]');
        }

        if (onetimeSelected) {
          console.log('One-time purchase is selected');
          return false;
        }

        if (subscriptionSelected) {
          console.log('Subscription is selected');
          return true;
        }

        return false;
      }

      async addGiftProduct(quantity) {
        try {
          const giftHandle = window.subscriptionGiftSettings?.giftProductHandle || 'bonus-shaker-bottle';
          console.log('Fetching gift product...');
          const productResponse = await fetch(`/products/${giftHandle}.js`);
          const product = await productResponse.json();
          
          if (product.variants && product.variants.length > 0) {
            const variantId = product.variants[0].id;
            
            localStorage.setItem('allowFreeGiftAdd', 'true');
            
            console.log('Adding gift to cart, variant:', variantId);
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: quantity
              })
            });
            
            const result = await addResponse.json();
            console.log('Gift added to cart:', result);
            return result;
          }
        } catch (error) {
          console.error('Error adding gift product:', error);
          throw error;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
